<template>
  <v-dialog max-width="422px" v-model="openModal.flag">
    <v-card>
      <v-card-title class="title"> Leave Group </v-card-title>
      <v-card-text class="text-center">
        <div class="mt-6">
          <v-img class="alert" :src="alert"> </v-img>
          <div class="sub-title mt-4">
            Are you sure you want to leave the group?
          </div>
          <div class="below_sub-title mt-2 mb-4">
            Once you leave the group, you’ll no longer see any updates or posts.
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="justify-center pb-5">
        <v-btn
          @click="openModal.flag = false"
          color="primary"
          class="text-capitalize leave-buttons"
          outlined
        >
          Cancel
        </v-btn>
        <v-btn
          class="text-capitalize leave-buttons"
          @click="leaveGroup(openModal.group)"
          color="primary"
        >
          Leave Group
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "LeaveGroupComponent",
  props: ["openModal"],
  data() {
    return {
      alert: require("@/assets/images/alert.png"),
    };
  },

  methods: {
    leaveGroup(group) {
      this.eventBus.$emit("leave-group", {
        group: group,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.alert {
  width: 84.67px;
  height: 76px;
  margin-left: auto;
  margin-right: auto;
}
.title {
  background-color: #2d8cff;
  color: white;
}
.sub-title {
  font-family: Avenir;
  font-size: 16px;
  font-weight: 800;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: center;
}
.below_sub-title {
  font-family: Avenir;
  font-size: 14px;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: center;
}
.leave-buttons {
  width: 180px;
  height: 42px;
}
@media only screen and (max-width: 600px) {
  .leave-buttons {
    width: 140px;
    height: 38px;
  }
  .below_sub-title {
    font-size: 10px;
  }
  .sub-title {
    font-size: 13px;
  }
}
</style>
